<script setup>
import Icon from "@/v2/primitives/Icon/Icon.vue";
import { ref, onMounted, nextTick } from "vue";

const props = defineProps({
  query: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
    required: true,
  },
});

defineEmits(["input"]);

const searchInput = ref(null);

onMounted(() => {
  if (props.readonly) return;
  nextTick(() => searchInput.value?.focus());
});
</script>

<template>
  <div class="search-input">
    <div
      class="search-input--container"
      :class="{
        'search-input--container-active': query?.length,
      }"
    >
      <Icon
        class="search-input--icon"
        :class="{
          'search-input--icon-active': query?.length,
        }"
        name="search"
      />

      <input
        ref="searchInput"
        class="search-input--input"
        placeholder="What are you looking for?"
        data-testid="search-input"
        autocomplete="false"
        spellcheck="false"
        :value="query"
        :readonly
        @input="$emit('input', $event.target.value)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/v2/primitives/Text/text-variants";

.search-input {
  position: relative;
  padding-right: var(--spacing-lg);
  height: 100%;
  width: 100%;
  display: flex;

  @include min-width-sm-and-height-sm {
    padding-right: 0;
  }

  &--container {
    border-bottom: 2px solid var(--search-input-divider);
    display: flex;
    gap: var(--spacing-base);
    align-items: center;
    width: 100%;
  }

  &--container-active {
    border-bottom: 2px solid var(--search-input-active-text);
  }

  &--icon {
    display: flex;
    width: 1.5rem;
    height: 1.5rem;
    color: var(--search-input-icon);

    @include min-width-sm {
      height: 40px;
      width: 40px;
    }
  }

  &--icon-active {
    color: var(--search-input-active-text);
  }

  &--input {
    border: none;
    outline: none;
    display: flex;
    width: 100%;
    color: var(--search-input-active-text);
    background: transparent;

    @include text-body-large;

    @include min-width-sm {
      @include text-title2;
    }

    @include min-width-md {
      @include text-title1;
    }

    &::placeholder {
      color: var(--search-input-placeholder-text);
    }
  }
}
</style>
